'use strict';

var cov_1zeczi1tpx = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/routes.js',
      hash = '42359fb8f3050c93d61f68539b38da982796cf20',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/routes.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 3,
          column: 24
        }
      },
      '1': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 52
        }
      },
      '2': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 36
        }
      },
      '3': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 14,
          column: 7
        }
      },
      '4': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 28,
          column: 7
        }
      },
      '5': {
        start: {
          line: 22,
          column: 10
        },
        end: {
          line: 22,
          column: 46
        }
      },
      '6': {
        start: {
          line: 25,
          column: 10
        },
        end: {
          line: 25,
          column: 41
        }
      }
    },
    fnMap: {
      '0': {
        name: 'routesConfig',
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 21
          }
        },
        loc: {
          start: {
            line: 6,
            column: 77
          },
          end: {
            line: 29,
            column: 1
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 21,
            column: 20
          },
          end: {
            line: 21,
            column: 21
          }
        },
        loc: {
          start: {
            line: 21,
            column: 36
          },
          end: {
            line: 23,
            column: 9
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 24,
            column: 15
          },
          end: {
            line: 24,
            column: 16
          }
        },
        loc: {
          start: {
            line: 24,
            column: 45
          },
          end: {
            line: 26,
            column: 9
          }
        }
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1zeczi1tpx.s[0];
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  ++cov_1zeczi1tpx.f[0];
  ++cov_1zeczi1tpx.s[1];

  $locationProvider.html5Mode(true).hashPrefix('!');
  ++cov_1zeczi1tpx.s[2];
  $urlRouterProvider.otherwise('/');

  ++cov_1zeczi1tpx.s[3];
  $stateProvider.state('main', {
    url: '/',
    component: 'main'
  });

  ++cov_1zeczi1tpx.s[4];
  $stateProvider.state('dashboard', {
    url: '/dashboard',
    component: 'dashboard',
    resolve: {
      indicators: function indicators(MartyService) {
        ++cov_1zeczi1tpx.f[1];
        ++cov_1zeczi1tpx.s[5];

        return MartyService.getIndicators();
      },
      marts: function marts(indicators, MartyService) {
        ++cov_1zeczi1tpx.f[2];
        ++cov_1zeczi1tpx.s[6];

        return MartyService.getMarts();
      }
    }
  });
}